export interface PortalWidgetSettings {
  widgets: PortalWidget[];
}

export interface PortalWidget {
  id: string;
  name: string;
  predefinedType?: PredefinedPortalWidgetType;
  reportId?: string;
  status: PortalWidgetStatus;
  includeRowDetails?: boolean;
  footnote?: string;
}

export type PredefinedPortalWidgetType = "Balance" | "CashFlows" | "Portfolio" | "News";

export const allPortalWidgetStatuses = ["Off", "Preview", "Live"] as const;

export type PortalWidgetStatus = (typeof allPortalWidgetStatuses)[number];
